import React from 'react';
import styled from 'styled-components';

const Track = styled.div`
  width: 100%;
  height: 6px;
  flex-shrink: 0;
  border-radius: 3px;
  background-color: var(--color-studio-cell-outline);
  overflow: hidden;
`;

const Fill = styled.div<{ $percent: number; $color: string }>`
  width: ${(props) => props.$percent}%;
  height: 100%;
  border-radius: 3px;
  background-color: ${(props) => props.$color};
  transition: width 0.3s ease;
`;

// A Number's share of its "Out of" metric, as a bar. Empty until the share
// is known; full beyond 100%.
const ProgressBar = ({
  percent,
  color,
  testId,
}: {
  percent: number | undefined;
  color: string;
  testId: string;
}) => {
  const clamped =
    percent === undefined ? 0 : Math.min(100, Math.max(0, percent));
  return (
    <Track
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={percent === undefined ? undefined : Math.round(percent)}
      data-testid={testId}
    >
      <Fill $percent={clamped} $color={color} />
    </Track>
  );
};

export default ProgressBar;
